import { gql } from "@apollo/client";
import moment from "moment";
import { VALORACION_ACCESO_INTEGRO_ID, VALORACION_ACCESO_PERMEABLE_ID } from "../../../../Pages/MisVisitasCreation/constants/valoracionAccesoIds";
import { PROCEDIMIENTO_CONEXION_ID, PROCEDIMIENTO_DESCONEXION_ID } from "../../../../Pages/MisVisitasCreation/constants/procedimientoConexionIds";
import { unifyFechaHora } from "../../../../helpers/unifyFechaHora";

export const GET_VISITA = gql`
  query visita($idVisita: Int!) {
    visita(idVisita: $idVisita) {
      idVisita
      idEvaluacion
      direccion
      posX
      posY
      idFrecuencia
      idUsuarioCreador
      idTipoProfesional
      idProfesional
      idComboVisitaValorTipoVisita
      idEstado
      fechaVisita
      tiempoEspera
      explicacion
      idComboVisitaValorFormaVisita
      idComboVisitaValorPacienteDomicilio
      idUltimaVisita
      evolucion
      codigoAtencion
      idComboVisitaValorInterlocutor
      nombreCompleto
      dNI
      email
      capacitacion
      justificacionHoras
      conformidad
      obsConformidad
      kinesioRespiratoria
      kinesioMotora
      idComboVisitaValorTipoVisita
      fechaFinUsuario
    }
  }
`;
export const adaptVisitaGeneral = (v) => ({
  idVisita: v?.idVisita,
  idEvaluacion: v?.idEvaluacion,
  direccion: v?.direccion,
  posX: v?.posX,
  posY: v?.posY,
  idFrecuencia: v?.idFrecuencia,
  idTipoProfesional: v?.idTipoProfesional,
  idProfesional: v?.idProfesional,
  idComboVisitaValorTipoVisita: v?.idComboVisitaValorTipoVisita,
  idEstado: v?.idEstado,
  fechaVisita: v?.fechaVisita,
  fechaFin: v?.fechaFinUsuario,
  tiempoEspera: v?.tiempoEspera,
  explicacion: v?.explicacion,
  idComboVisitaValorFormaVisita: v?.idComboVisitaValorFormaVisita,
  idComboVisitaValorPacienteDomicilio: v?.idComboVisitaValorPacienteDomicilio,
  idDatosGeneralesRI: v?.idDatosGeneralesRI,
  idUltimaVisita: v?.idUltimaVisita,
  codigoAtencion: v?.codigoAtencion,
  idComboVisitaValorInterlocutor: v?.idComboVisitaValorInterlocutor,
  nombreCompleto: v?.nombreCompleto,
  interlocutorNombre: v?.nombreCompleto,
  dNI: v?.dNI,
  email: v?.email,
  capacitacion: !!v?.capacitacion,
  justificacion: v?.justificacionHoras,
  conformidad: !!v?.conformidad,
  obsConformidad: v?.obsConformidad,
  kinesioRespiratoria: !!v?.kinesioRespiratoria,
  kinesioMotora: !!v?.kinesioMotora,
  evolucion: v?.evolucion,
  idUsuarioCreador: v?.idUsuarioCreador
});

// Tele-Enfermería
export const GET_VISITA_TELE_AE = gql`
  query visitaTeleEnfermeriaAE($idVisita: Int!) {
    visitaTeleEnfermeriaAE(idVisita: $idVisita) {
      idTeleEnfermeriaAE
      idVisita
      accesoDescripcion
      notaAlteracion
      supuracion
      eritemas
      granulomasFuga
      resistenciaPermeabilidad
      estaPermeable
      fijacionDescripcionAE
      marcaReferenciaDespla
      seDesplazo
      accionSiDesplazo
      frecLavadoAcceso
      formaLavadoAcceso
      fechaUltimoCambioSonda
      quienCambioSonda
      idMetodoAdministracion
      observacionGeneral
      idBombaInfusionNavigation {
        estaEnchufada
        funcionamientoAdecuado
        remanenteBolsa
        mantenimientoBomba
        alarmasSuenan
        modeloBomba
        reemplazoBomba
        velocidadAdministraForm
      }
      idCumplimientoIndicacionNavigation{
        idCumplimientoIndicacion
        cambioIndicacionSemana
        dificultadCumplimiento
        realizaEscalonamiento
        indicacionActual
        volumenDiario
        bolsaUtilizada
        velocidadPasaje
        horarioConexion
        quienRealizaCI
        procesoConexionDesconexion
        complementaViaOral
      }
      idParametrosControlClinicoNavigation{
        idParametrosControlClinico
        comoSintioDias
        modifAnimoActividad
        sienteDolor
        tuvoFiebre
        presion
        situacionClinicaAvisar
        nauseas
        vomito
        diarrea
        constipacion
        controlGlucemia
        llamadaMedicoMotivo
        comoSienteAbdomen
      }
      idInsumoCapacitacionNavigation{
        idInsumoCapacitacion
        insumoVencido
        cantidadSuficiente
        reclamoCantidadCalidad
        observacionCapacitacion
      }
    }
  }
`;

// --- TELE ---
export const adaptVisitaTeleEnfermeriaAE = (data) => ({
  idVisita: data?.idVisita,
  idTeleEnfermeriaAE: data?.idTeleEnfermeriaAE,
  accesoDescripcion: data?.accesoDescripcion || "",
  notaAlteracion: data?.notaAlteracion || "",
  supuracion: !!data?.supuracion,
  eritemas: !!data?.eritemas,
  granulomasFuga: !!data?.granulomasFuga,
  resistenciaPermeabilidad: !!data?.resistenciaPermeabilidad,
  estaPermeable: !!data?.estaPermeable,
  fijacionDescripcionAE: data?.fijacionDescripcionAE || "",
  marcaReferenciaDespla: data?.marcaReferenciaDespla || "",
  seDesplazo: !!data?.seDesplazo,
  accionSiDesplazo: data?.accionSiDesplazo || "",
  frecLavadoAcceso: data?.frecLavadoAcceso || "",
  formaLavadoAcceso: data?.formaLavadoAcceso || "",
  fechaUltimoCambioSonda: data?.fechaUltimoCambioSonda || "",
  quienCambioSonda: data?.quienCambioSonda || "",
  idMetodoAdministracion: data?.idMetodoAdministracion,
  observacionGeneral: data?.observacionGeneral || "",
  estaEnchufada: !!data?.idBombaInfusionNavigation?.estaEnchufada,
  funcionamientoAdecuado: !!data?.idBombaInfusionNavigation?.funcionamientoAdecuado,
  remanenteBolsa: data?.idBombaInfusionNavigation?.remanenteBolsa || "",
  mantenimientoBomba: data?.idBombaInfusionNavigation?.mantenimientoBomba || "",
  alarmasSuenan: !!data?.idBombaInfusionNavigation?.alarmasSuenan,
  modeloBomba: data?.idBombaInfusionNavigation?.modeloBomba || "",
  reemplazoBomba: data?.idBombaInfusionNavigation?.reemplazoBomba || "",
  velocidadAdministraForm: data?.idBombaInfusionNavigation?.velocidadAdministraForm || "",
  idCumplimientoIndicacion: data?.idCumplimientoIndicacionNavigation?.idCumplimientoIndicacion || 0,
  cambioIndicacionSemana: data?.idCumplimientoIndicacionNavigation?.cambioIndicacionSemana,
  dificultadCumplimiento: data?.idCumplimientoIndicacionNavigation?.dificultadCumplimiento,
  realizaEscalonamiento: data?.idCumplimientoIndicacionNavigation?.realizaEscalonamiento,
  indicacionActual: data?.idCumplimientoIndicacionNavigation?.indicacionActual,
  volumenDiario: data?.idCumplimientoIndicacionNavigation?.volumenDiario,
  bolsaUtilizada: data?.idCumplimientoIndicacionNavigation?.bolsaUtilizada,
  velocidadPasaje: data?.idCumplimientoIndicacionNavigation?.velocidadPasaje,
  horarioConexion: data?.idCumplimientoIndicacionNavigation?.horarioConexion,
  quienRealizaCI: data?.idCumplimientoIndicacionNavigation?.quienRealizaCI,
  procesoConexionDesconexion: data?.idCumplimientoIndicacionNavigation?.procesoConexionDesconexion,
  complementaViaOral: data?.idCumplimientoIndicacionNavigation?.complementaViaOral,
  idParametrosControlClinico: data?.idParametrosControlClinicoNavigation?.idParametrosControlClinico || 0,
  comoSintioDias: data?.idParametrosControlClinicoNavigation?.comoSintioDias,
  modifAnimoActividad: data?.idParametrosControlClinicoNavigation?.modifAnimoActividad,
  sienteDolor: data?.idParametrosControlClinicoNavigation?.sienteDolor,
  tuvoFiebre: data?.idParametrosControlClinicoNavigation?.tuvoFiebre,
  presion: data?.idParametrosControlClinicoNavigation?.presion,
  situacionClinicaAvisar: data?.idParametrosControlClinicoNavigation?.situacionClinicaAvisar,
  nauseas: data?.idParametrosControlClinicoNavigation?.nauseas,
  vomito: data?.idParametrosControlClinicoNavigation?.vomito,
  diarrea: data?.idParametrosControlClinicoNavigation?.diarrea,
  constipacion: data?.idParametrosControlClinicoNavigation?.constipacion,
  controlGlucemia: data?.idParametrosControlClinicoNavigation?.controlGlucemia,
  llamadaMedicoMotivo: data?.idParametrosControlClinicoNavigation?.llamadaMedicoMotivo,
  comoSienteAbdomen: data?.idParametrosControlClinicoNavigation?.comoSienteAbdomen,
  idInsumoCapacitacion: data?.idInsumoCapacitacionNavigation?.idInsumoCapacitacion || 0,
  insumoVencido: data?.idInsumoCapacitacionNavigation?.insumoVencido,
  cantidadSuficiente: data?.idInsumoCapacitacionNavigation?.cantidadSuficiente,
  reclamoCantidadCalidad: data?.idInsumoCapacitacionNavigation?.reclamoCantidadCalidad,
  observacionCapacitacion: data?.idInsumoCapacitacionNavigation?.observacionCapacitacion
});


export const GET_VISITA_TELE_AP = gql`
  query visitaTeleEnfermeriaAP($idVisita: Int!) {
    visitaTeleEnfermeriaAP(idVisita: $idVisita) {
      idTeleEnfermeriaAP
      idVisita
      estaPermeable
      fijacionDesc
      seDesplazo
      accionSiDesplazo
      frecuenciaCuracion
      formaCuracion
      fechaUltimaCuracion
      quienLoHizo
      cateterConBionector
      granulomaSangrado
      eritemas
      supuracion
      dolor
      notaAlteracion
      sitioSalidaEstado
      cadaCuantoCambia
      comoDesinfecta
      parche
      idCumplimientoIndicacion
      idBombaInfusion
      idParametrosControlClinico
      idInsumoCapacitacion
      idBombaInfusionNavigation {
        estaEnchufada
        funcionamientoAdecuado
        remanenteBolsa
        mantenimientoBomba
        alarmasSuenan
        modeloBomba
        reemplazoBomba
        velocidadAdministraForm
      }
      idCumplimientoIndicacionNavigation {
        idCumplimientoIndicacion
        cambioIndicacionSemana
        dificultadCumplimiento
        realizaEscalonamiento
        indicacionActual
        volumenDiario
        bolsaUtilizada
        velocidadPasaje
        horarioConexion
        quienRealizaCI
        procesoConexionDesconexion
        complementaViaOral
      }
      idParametrosControlClinicoNavigation {
        idParametrosControlClinico
        comoSintioDias
        modifAnimoActividad
        sienteDolor
        tuvoFiebre
        presion
        situacionClinicaAvisar
        nauseas
        vomito
        diarrea
        constipacion
        controlGlucemia
        llamadaMedicoMotivo
        comoSienteAbdomen
      }
      idInsumoCapacitacionNavigation {
        idInsumoCapacitacion
        insumoVencido
        cantidadSuficiente
        reclamoCantidadCalidad
        observacionCapacitacion
      }
    }
  }
`;

export const adaptVisitaTeleEnfermeriaAP = (data) => ({
  idVisita: data?.idVisita,
  idTeleEnfermeriaAP: data?.idTeleEnfermeriaAP,
  permeable: !!data?.estaPermeable,
  fijacion: data?.fijacionDesc || "",
  desplazo: !!data?.seDesplazo,
  accionDesplazo: data?.accionSiDesplazo || "",
  frecuenciaCuracion: data?.frecuenciaCuracion || "",
  formaCuracion: data?.formaCuracion || "",
  fechaUltimaCuracion: data?.fechaUltimaCuracion || "",
  quienCuro: data?.quienLoHizo || "",
  bionector: !!data?.cateterConBionector,
  granulomasSangrado: !!data?.granulomaSangrado,
  eritemas: !!data?.eritemas,
  supuracion: !!data?.supuracion,
  dolor: !!data?.dolor,
  alteracionLlamativa: data?.notaAlteracion || "",
  sitioSalida: data?.sitioSalidaEstado || "",
  cadaCuantoCambia: data?.cadaCuantoCambia || "",
  desinfeccion: data?.comoDesinfecta || "",
  parche: data?.parche || "",
  // Bomba de infusión (navegación)
  idBombaInfusionTelemedicina: data?.idBombaInfusion || 0,
  estaEnchufada: !!data?.idBombaInfusionNavigation?.estaEnchufada,
  funcionamientoAdecuado: !!data?.idBombaInfusionNavigation?.funcionamientoAdecuado,
  remanenteBolsa: data?.idBombaInfusionNavigation?.remanenteBolsa || "",
  mantenimientoBomba: data?.idBombaInfusionNavigation?.mantenimientoBomba || "",
  alarmasSuenan: !!data?.idBombaInfusionNavigation?.alarmasSuenan,
  modeloBomba: data?.idBombaInfusionNavigation?.modeloBomba || "",
  reemplazoBomba: data?.idBombaInfusionNavigation?.reemplazoBomba || "",
  velocidadAdministraForm: data?.idBombaInfusionNavigation?.velocidadAdministraForm || "",
  // Cumplimiento indicación (navegación)
  idCumplimientoIndicacion: data?.idCumplimientoIndicacionNavigation?.idCumplimientoIndicacion || 0,
  cambioIndicacion: data?.idCumplimientoIndicacionNavigation?.cambioIndicacionSemana,
  dificultadCumplimiento: data?.idCumplimientoIndicacionNavigation?.dificultadCumplimiento,
  realizaEscalonamiento: data?.idCumplimientoIndicacionNavigation?.realizaEscalonamiento,
  indicacionRealizando: data?.idCumplimientoIndicacionNavigation?.indicacionActual,
  volumenPorDia: data?.idCumplimientoIndicacionNavigation?.volumenDiario,
  bolsaUtilizando: data?.idCumplimientoIndicacionNavigation?.bolsaUtilizada,
  velocidadBolsa: data?.idCumplimientoIndicacionNavigation?.velocidadPasaje,
  horaConexion: data?.idCumplimientoIndicacionNavigation?.horarioConexion,
  quienLoHace: data?.idCumplimientoIndicacionNavigation?.quienRealizaCI,
  procesoConexion: data?.idCumplimientoIndicacionNavigation?.procesoConexionDesconexion,
  complementaViaOral: data?.idCumplimientoIndicacionNavigation?.complementaViaOral,
  // Parámetros control clínico (navegación)
  idParametrosControlClinico: data?.idParametrosControlClinicoNavigation?.idParametrosControlClinico || 0,
  comoSeSintio: data?.idParametrosControlClinicoNavigation?.comoSintioDias,
  modificacionesEstado: data?.idParametrosControlClinicoNavigation?.modifAnimoActividad,
  sienteDolor: data?.idParametrosControlClinicoNavigation?.sienteDolor,
  tuvoFiebre: data?.idParametrosControlClinicoNavigation?.tuvoFiebre,
  comoEstaPresion: data?.idParametrosControlClinicoNavigation?.presion,
  situacionClinica: data?.idParametrosControlClinicoNavigation?.situacionClinicaAvisar,
  nauseas: data?.idParametrosControlClinicoNavigation?.nauseas,
  vomito: data?.idParametrosControlClinicoNavigation?.vomito,
  diarrea: data?.idParametrosControlClinicoNavigation?.diarrea,
  constipacion: data?.idParametrosControlClinicoNavigation?.constipacion,
  controlGlucemia: data?.idParametrosControlClinicoNavigation?.controlGlucemia,
  llamadaMedicoMotivo: data?.idParametrosControlClinicoNavigation?.llamadaMedicoMotivo,
  comoSienteAbdomen: data?.idParametrosControlClinicoNavigation?.comoSienteAbdomen,
  // Insumo capacitación (navegación)
  idInsumoCapacitacion: data?.idInsumoCapacitacionNavigation?.idInsumoCapacitacion || 0,
  insumoVencido: data?.idInsumoCapacitacionNavigation?.insumoVencido,
  cantidadSuficiente: data?.idInsumoCapacitacionNavigation?.cantidadSuficiente,
  reclamoCantidadCalidad: data?.idInsumoCapacitacionNavigation?.reclamoCantidadCalidad,
  observacionCapacitacion: data?.idInsumoCapacitacionNavigation?.observacionCapacitacion
});

export const GET_VISITA_TELE_CP = gql`
  query visitaTeleEnfermeriaCP($idVisita: Int!) {
    visitaTeleEnfermeriaCP(idVisita: $idVisita) {
      idTeleEnfermeriaCP
      idVisita
      apetito
      gradoDolor
      catarsis
      obsCatarsis
      diuresis
      cantidad
      obsDiuresis
      horaCama
      sentimiento
      preocupacion
      repasoIndicacion
      ampliarConcepto
    }
  }
`;

export const adaptVisitaTeleEnfermeriaCP = (data) => ({
  idVisita: data?.idVisita,
  idTeleEnfermeriaCP: data?.idTeleEnfermeriaCP,
  apetito: data?.apetito || "",
  gradoDolor: data?.gradoDolor || null,
  catarsis: !!data?.catarsis,
  obsCatarsis: data?.obsCatarsis || "",
  diuresis: !!data?.diuresis,
  cantidad: data?.cantidad || null,
  obsDiuresis: data?.obsDiuresis || "",
  horaCama: data?.horaCama || null,
  sentimiento: data?.sentimiento || "",
  preocupacion: data?.preocupacion || "",
  repasoIndicacion: data?.repasoIndicacion || "",
  ampliarConcepto: data?.ampliarConcepto || ""
});

// Presenciales
export const GET_VISITA_PRESENCIAL_AE = gql`
  query visitaPresencialAE($idVisita: Int!) {
    visitaPresencialAE(idVisita: $idVisita) {
      idPresencialAE
      idVisita
      distencion
      constipacion
      diarrea
      diuresis
      cantidad
      toleranciaTratamiento
      obsTolerancia
      cumplimientoIndicacion
      obsCumplimientoIndicacion
      tensionArterial
      temperatura
      frecuenciaCardiaca
      frecuenciaRespiratoria
      fijacionAcceso
      curacionAcceso
      bombaInfusion
      cambioSonda
      controlPH
      condicionAlmacenamiento
      obsCondicionAlmacenamiento
      stockProductos
      obsStockProductos
      solicitaRXControl
      observaciones
      controlUbicacionPH
      tiempoAyunoPrevio
      cantidadMuestraExtraida
      tipoSonda
      lote
      vencimientoLote
      aspectoSimilMocoLeche
      aspectoSimilLecheCortada
      colorLechoso
      colorRojizo
      colorNegruzco
      autorizaLiquidoAcuoso
      autorizaFilante
      autorizaColorAmarronado
      autorizaColorAmarillento
      autorizaColorVerdeOscuro
      integro
      permeable
      resultadoPH{
        idResultadoPH
        resultado
        posicion
      }
    }
  }
`;

export const adaptVisitaPresencialAE = (data) => {
  const acceso = [];
  if (data?.integro) acceso.push(VALORACION_ACCESO_INTEGRO_ID);
  if (data?.permeable) acceso.push(VALORACION_ACCESO_PERMEABLE_ID);

  return {
    idVisita: data?.idVisita ?? null,
    idPresencialAE: data?.idPresencialAE ?? null,

    // GI / Eliminación
    distencion: !!data?.distencion,
    constipacion: !!data?.constipacion,
    diarrea: !!data?.diarrea,
    diuresis: !!data?.diuresis,
    cantidadDiuresis: data?.cantidad ?? null,

    // Tratamiento / Cumplimiento
    toleranciaTratamiento: !!data?.toleranciaTratamiento,
    obsTolerancia: data?.obsTolerancia || "",
    cumplimientoIndicacion: !!data?.cumplimientoIndicacion,
    obsCumplimientoIndicacion: data?.obsCumplimientoIndicacion || "",

    // Signos vitales
    tensionArterial: data?.tensionArterial || "",
    temperatura: data?.temperatura ?? null,
    frecuenciaCardiaca: data?.frecuenciaCardiaca ?? null,
    frecuenciaRespiratoria: data?.frecuenciaRespiratoria ?? null,

    // Acceso / Dispositivos
    accesoIntegro: !!data?.integro,
    accesoPermeable: !!data?.permeable,
    fijacionAcceso: !!data?.fijacionAcceso,
    curacionAcceso: !!data?.curacionAcceso,
    bombaInfusion: !!data?.bombaInfusion,
    cambioSonda: !!data?.cambioSonda,

    // pH / Ubicación
    controlPH: !!data?.controlPH,
    controlUbicacionPH: !!data?.controlUbicacionPH,

    // Almacenamiento / Stock
    condicionAlmacenamiento: !!data?.condicionAlmacenamiento,
    obsCondicionAlmacenamiento: data?.obsCondicionAlmacenamiento || "",
    stockProductos: !!data?.stockProductos,
    obsStockProductos: data?.obsStockProductos || "",
    listResultadoPH: data?.resultadoPH?.map((r) => ({
      posicion: r?.posicion,
      resultado: r?.resultado
    })) || [],
    // RX / Observaciones
    solicitaRXControl: !!data?.solicitaRXControl,
    observaciones: data?.observaciones || "",

    // Toma de muestra / Sonda
    tiempoAyunoPrevio: data?.tiempoAyunoPrevio ?? null,
    cantidadMuestraExtraida: data?.cantidadMuestraExtraida ?? null,
    tipoSonda: data?.tipoSonda || "",
    lote: data?.lote || "",
    vencimientoLote: data?.vencimientoLote ? new Date(data.vencimientoLote) : null,

    // Aspectos del contenido (líquidos/colores)
    aspectoSimilMocoLeche: !!data?.aspectoSimilMocoLeche,
    aspectoSimilLecheCortada: !!data?.aspectoSimilLecheCortada,
    colorLechoso: !!data?.colorLechoso,
    colorRojizo: !!data?.colorRojizo,
    colorNegruzco: !!data?.colorNegruzco,

    // Autorizaciones
    autorizaLiquidoAcuoso: !!data?.autorizaLiquidoAcuoso,
    autorizaFilante: !!data?.autorizaFilante,
    autorizaColorAmarronado: !!data?.autorizaColorAmarronado,
    autorizaColorAmarillento: !!data?.autorizaColorAmarillento,
    autorizaColorVerdeOscuro: !!data?.autorizaColorVerdeOscuro,

    // Estado acceso
    // acceso: acceso
  };
};

export const GET_VISITA_PRESENCIAL_AP = gql`
  query visitaPresencialAP($idVisita: Int!) {
    visitaPresencialAP(idVisita: $idVisita) {
      idPresencialAP
      idVisita
      observacionSitioPuncion
      presenciaEdemas
      diuresis
      cantidad
      estadoHidratacionOptimo
      obsHidratacionNo
      controlGlucemia
      tensionArterial
      temperatura
      frecuenciaCardiaca
      frecuenciaRespiratoria
      procedimientoConexion
      procedimientoDesconexion
      curacionCateter
      cambioBionector
      controlBomba
      condicionAlmacenamiento
      obsAlmacenamientoNo
      stockProductos
      obsStockNo
      permeable
      valorGlucemia
      integro
    }
  }
`;

export const adaptVisitaPresencialAP = (data) => {
  
  const acceso = [];
  const procedimiento = [];
  if (data?.integro) acceso.push(VALORACION_ACCESO_INTEGRO_ID);
  if (data?.permeable) acceso.push(VALORACION_ACCESO_PERMEABLE_ID);
  if (data?.procedimientoConexion) procedimiento.push(PROCEDIMIENTO_CONEXION_ID);
  if (data?.procedimientoDesconexion) procedimiento.push(PROCEDIMIENTO_DESCONEXION_ID);

  return {
    idVisita: data?.idVisita,
    idPresencialAP: data?.idPresencialAP,
    observacionSitioPuncion: data?.observacionSitioPuncion || "",
    presenciaEdemas: !!data?.presenciaEdemas,
    diuresis: !!data?.diuresis,
    cantidad: data?.cantidad ?? null,
    estadoHidratacionOptimo: !!data?.estadoHidratacionOptimo,
    obsHidratacionNo: data?.obsHidratacionNo || "",
    controlGlucemia: !!data?.controlGlucemia,
    tensionArterial: data?.tensionArterial || "",
    temperatura: data?.temperatura ?? null,
    frecuenciaCardiaca: data?.frecuenciaCardiaca ?? null,
    frecuenciaRespiratoria: data?.frecuenciaRespiratoria ?? null,
    curacionCateter: !!data?.curacionCateter,
    cambioBionector: !!data?.cambioBionector,
    controlBomba: !!data?.controlBomba,
    condicionAlmacenamiento: !!data?.condicionAlmacenamiento,
    obsAlmacenamientoNo: data?.obsAlmacenamientoNo || "",
    stockProductos: !!data?.stockProductos,
    obsStockNo: data?.obsStockNo || "",
    accesoIntegro: !!data?.integro,
    accesoPermeable: !!data?.permeable,
    valorGlucemia: data?.valorGlucemia || "",
    // acceso: acceso,
    procedimiento: procedimiento
  };
};

export const GET_VISITA_PRESENCIAL_CPCD = gql`
   query visitaPresencialCPCD($idVisita: Int!) {
    visitaPresencialCPCD(idVisita: $idVisita) {
      idPresencialCPCD
      idVisita
      eCOG
      karnofsky
      escaras
      estadio
      diuresis
      cantidad
      catarsis
      caracteristicas
      controlSignosVitales
      justifSinSignos
      tensionArterial
      temperatura
      frecuenciaCardiaca
      frecuenciaRespiratoria
      sPO2
      cambioSondaVesical
      aspiracionSecreciones
      curacionLesiones
      adminMedicamentos
      otros
      idESAS
      eCOGNavigation {
        idComboVisitaValor
        valor
        activo
      }
      karnofskyNavigation {
        idComboVisitaValor
        valor
        activo
      }
      idESASNavigation {
        idEsas
        nauseas
        dolor
        disnea
        ansiedad
        depresion
        anorexia
        bienestar
        cansancio
        insomnio
        somnolencia
        constipacion
        resultadoESAS
      }
    }
  }
`;

export const adaptVisitaPresencialCPCD = (data) => ({
  idVisita: data?.idVisita,
  idPresencialCPCD: data?.idPresencialCPCD,
  eCOG: data?.eCOG ?? data?.eCOGNavigation?.idComboVisitaValor ?? null,
  karnofsky: data?.karnofsky ?? data?.karnofskyNavigation?.idComboVisitaValor ?? null,
  estadio: data?.estadio ?? null,
  escaras: !!data?.escaras,
  diuresis: !!data?.diuresis,
  catarsis: !!data?.catarsis,
  controlSignosVitales: !!data?.controlSignosVitales,
  cambioSondaVesical: !!data?.cambioSondaVesical,
  aspiracionSecreciones: !!data?.aspiracionSecreciones,
  curacionLesiones: !!data?.curacionLesiones,
  adminMedicamentos: !!data?.adminMedicamentos,
  caracteristicas: data?.caracteristicas || "",
  justifSinSignos: data?.justifSinSignos || "",
  tensionArterial: data?.tensionArterial || "",
  otros: data?.otros || "",
  cantidadDiuresis: data?.cantidad ?? null,
  temperatura: data?.temperatura ?? null,
  frecuenciaCardiaca: data?.frecuenciaCardiaca ?? null,
  frecuenciaRespiratoria: data?.frecuenciaRespiratoria ?? null,
  spo2: data?.sPO2 ?? null,
  idESAS: data?.idESASNavigation?.idEsas ?? data?.idESAS ?? null,
  nauseas: data.idESASNavigation?.nauseas ?? null,
  dolor: data.idESASNavigation?.dolor ?? null,
  disnea: data.idESASNavigation?.disnea ?? null,
  ansiedad: data.idESASNavigation?.ansiedad ?? null,
  depresion: data.idESASNavigation?.depresion ?? null,
  anorexia: data.idESASNavigation?.anorexia ?? null,
  bienestar: data.idESASNavigation?.bienestar ?? null,
  cansancio: data.idESASNavigation?.cansancio ?? null,
  insomnio: data.idESASNavigation?.insomnio ?? null,
  somnolencia: data.idESASNavigation?.somnolencia ?? null,
  constipacion: data.idESASNavigation?.constipacion ?? null,
  resultadoESAS: data.idESASNavigation?.resultadoESAS ?? null
});